import { c as _c } from "react/compiler-runtime";
import type { TermoGlossarioSentenca } from '../../../types/sentencaArbitral.types';
import { TEXTOS_SENTENCA_ARBITRAL } from './secoesSentencaArbitral';
export function SecaoGlossarioIntro() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="px-[37px] pb-3"><p className="text-[14px] leading-[1.45] text-neutral-600">{TEXTOS_SENTENCA_ARBITRAL.glossarioIntro}</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
interface TabelaGlossarioSentencaProps {
  termos: readonly TermoGlossarioSentenca[];
}
export function TabelaGlossarioSentenca(t0) {
  const $ = _c(6);
  const {
    termos
  } = t0;
  let t1;
  if ($[0] !== termos) {
    let t2;
    if ($[2] !== termos.length) {
      t2 = (termo, index) => <div className={`grid grid-cols-1 px-5 py-[11px] sm:grid-cols-[230px_1fr] ${index < termos.length - 1 ? "border-b border-solid border-neutral-100" : ""}`} key={termo.termo}><div className="text-brand-600 pr-4 text-[13px] leading-[18px] font-bold">{termo.termo}</div><div className="text-[12.5px] leading-[1.6] text-neutral-600">{termo.explicacao}</div></div>;
      $[2] = termos.length;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    t1 = termos.map(t2);
    $[0] = termos;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div className="px-[37px] pb-[26px]"><div className="overflow-hidden rounded-[8px] border border-solid border-neutral-200">{t1}</div></div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}